
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import React from 'react';
import styled from "styled-components";
import {ChartLabel, XYPlot, XAxis, YAxis, VerticalGridLines, HorizontalGridLines, LineSeries} from 'react-vis';
import CovidCasesData from "../data/ActiveGSG_data_processed.json" 

// export default function CovidPlot(props) {

  const PlotBox = styled.div`
  background: rgba(45, 53, 60, 0.8);
  display: flex;
  right: 20px;
  top: 450px;
  position: absolute;
  z-index: 1;
  border-radius: 0.25rem;
  `;

  export const CovidCasesPlot = () => {
  return (
    <PlotBox>
      {/* <XYPlot height={300} width= {300}>
        <VerticalGridLines color='white' />
        <HorizontalGridLines />[
          {x: new Date('01/01/2018'), y: 75},
          {x: new Date('01/14/2018'), y: 60},
          {x: new Date('03/18/2018'), y: 80},
          {x: new Date(
        <XAxis title='Month' style={{
        line: {stroke: '#FFF'},
        ticks: {stroke: '#FFF'},
        text: {stroke: 'none', fill: '#FFF'}
      }} />
        <YAxis style={{
        line: {stroke: '#FFF'},
        ticks: {stroke: '#FFF'},
        text: {stroke: 'none', fill: '#FFF'}
      }} />
        <LineSeries data={data} />
      </XYPlot> */}
      <XYPlot
      margin={{left: 60}}
      xType="time"
      width={300}
      height={300}>
       <XAxis style={{
        line: {stroke: '#FFF'},
        ticks: {stroke: '#FFF'},
        text: {stroke: 'none', fill: '#FFF'}
      }} />
      <YAxis title="cases" style={{
        line: {stroke: '#FFF'},
        ticks: {stroke: '#FFF'},
        text: {stroke: 'none', fill: '#FFF'}
      }} />
      {/* <ChartLabel text="Covid-19 Cases"/> */}
      <LineSeries
        data={CovidCasesData.map(row => {
          return {x: new Date(row['Day of Date']), y: row['ActiveNumbers']}
        })}
        style={{ fill: '#a5a5a5' }} 
        stroke={'#a5a5a5'}
        />
  </XYPlot>
  </PlotBox>
  );
}

{/* <XYPlot
  margin={{left: 100}}
  width={300}
  height={300}>
  <XAxis/>
  <YAxis/>
  <HorizontalGridLines/>
  <VerticalGridLines/>
  <PolygonSeries
    data={lowBandData}
    color="#776E57"/>
  <MarkSeries
    data={data}
    color="#4DC19C" />
</XYPlot> */}